import { DestroyRef, inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  collection,
  collectionSnapshots,
  Firestore,
  query,
  where,
} from '@angular/fire/firestore';
import { EventClass, Event } from '@sleipai/sleip-models';
import { map, Observable } from 'rxjs';

@Injectable()
export class EventsService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  fetchEventsByHorseId(horseId: string): Observable<Event[]> {
    const eventsForHorseRef = collection(this.firestore, 'events');
    const q = query(eventsForHorseRef, where('horseId', '==', horseId));

    return collectionSnapshots(q).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((eventList) =>
        eventList.map(
          (event) =>
            new EventClass({
              id: event.id,
              ...event.data(),
            })
        )
      )
    );
  }
}
